export default "__VITE_ASSET__DuZB_pBg__"